<div>
  <footer class="text-white text-center text-lg-start border-footer py-3">
    <div class="container p-2">
      <div class="row mt-4">
        <!--Grid column-->
        <div class="col-lg-4 col-md-12 mb-4 mb-md-0">
          <img src="assets/img/nav/header_new.png" alt="logo-1" (click)="routeTo('/home')" style="cursor: pointer;">
          <div class="pt-4 d-flex flex-column">
            <span class="pb-1">Centro Funzionale Multirischi</span>
            <span class="pb-1">Protezione Civile Regione Campania</span>
            <span class="pb-1">Centro Direzionale C3 - 80143 Napoli</span>
            <span class="pb-1">Mail: <a class="linkclass"
                href="mailto:centrofunzionale@regione.campania.it">centrofunzionale&#64;regione.campania.it</a></span>
            <span>Pec: <a class="linkclass"
                href="mailto:dati.centrofunzionale@pec.regione.campania.it">centrofunzionale&#64;pec.regione.campania.it</a></span>
          </div>
          <div class="w-100 d-flex justify-content-center pt-4">
            <a href="http://www.technologyadvising.it/" target="_blank">
              <div class="logota" style="background-image: url('assets/images/logota.png')">
              </div>
            </a>
          </div>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-md-0 d-flex flex-column">
          <!-- <h5 class="mb-4">Links</h5> -->
          <div class="d-flex">
            <div class="link-list col-md-6 col-sm-12 d-flex flex-column align-item-center ml-1">
              <a class="modalLink" (click)="openModalLinks()">Link utili</a>
              <a [routerLink]="['/home']">Homepage</a>
              <a [routerLink]="['/meteo']">Meteo</a>
              <a [routerLink]="['/tempo-reale']">Tempo Reale</a>
              <a [routerLink]="['/dati']">Dati</a>
              <a [routerLink]="['/documenti']">Documenti</a>
            </div>
            <div class="link-list col-md-6 col-sm-12 d-flex flex-column align-item-center  ml-1">
              <a [routerLink]="['/home']">ICT</a>
              <a [routerLink]="['/news']">News</a>
              <a [routerLink]="['/chi-siamo']">Chi siamo</a>
              <a [routerLink]="['/disclaimer/cookies']">Cookie Policy</a>
              <a [routerLink]="['/disclaimer/privacy']">Privacy Policy</a>
              <a (click)="openCusSat()">Aiutaci a migliorare</a>
            </div>
          </div>
        </div>
        <!--Grid column-->

        <!--Grid column-->
        <div class="col-lg-4 col-md-6 mb-4 mb-md-0">
          <h5 class="mb-2">Socials</h5>
          <div class="mb-2">
            <div class="social-buttons">
              <a href="javascript:void(0)" class="social-button twitter" (click)="$event.preventDefault()">
                <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="X">
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                        fill="currentColor" id="X-Path">
                      </path>
                    </g>
                  </g>
                </svg>
              </a>
              <a href="javascript:void(0)" class="social-button facebook" (click)="$event.preventDefault()">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 310 310" xml:space="preserve">
                  <g id="XMLID_834_">
                    <path id="XMLID_835_" d="M81.703,165.106h33.981V305c0,2.762,2.238,5,5,5h57.616c2.762,0,5-2.238,5-5V165.765h39.064
                c2.54,0,4.677-1.906,4.967-4.429l5.933-51.502c0.163-1.417-0.286-2.836-1.234-3.899c-0.949-1.064-2.307-1.673-3.732-1.673h-44.996
                V71.978c0-9.732,5.24-14.667,15.576-14.667c1.473,0,29.42,0,29.42,0c2.762,0,5-2.239,5-5V5.037c0-2.762-2.238-5-5-5h-40.545
                C187.467,0.023,186.832,0,185.896,0c-7.035,0-31.488,1.381-50.804,19.151c-21.402,19.692-18.427,43.27-17.716,47.358v37.752H81.703
                c-2.762,0-5,2.238-5,5v50.844C76.703,162.867,78.941,165.106,81.703,165.106z"></path>
                  </g>
                </svg>
              </a>
              <a href="javascript:void(0)" class="social-button instagram" (click)="$event.preventDefault()">
                <svg width="800px" height="800px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1">
                    <g id="Dribbble-Light-Preview" transform="translate(-340.000000, -7439.000000)">
                      <g id="icons" transform="translate(56.000000, 160.000000)">
                        <path
                          d="M289.869652,7279.12273 C288.241769,7279.19618 286.830805,7279.5942 285.691486,7280.72871 C284.548187,7281.86918 284.155147,7283.28558 284.081514,7284.89653 C284.035742,7285.90201 283.768077,7293.49818 284.544207,7295.49028 C285.067597,7296.83422 286.098457,7297.86749 287.454694,7298.39256 C288.087538,7298.63872 288.809936,7298.80547 289.869652,7298.85411 C298.730467,7299.25511 302.015089,7299.03674 303.400182,7295.49028 C303.645956,7294.859 303.815113,7294.1374 303.86188,7293.08031 C304.26686,7284.19677 303.796207,7282.27117 302.251908,7280.72871 C301.027016,7279.50685 299.5862,7278.67508 289.869652,7279.12273 M289.951245,7297.06748 C288.981083,7297.0238 288.454707,7296.86201 288.103459,7296.72603 C287.219865,7296.3826 286.556174,7295.72155 286.214876,7294.84312 C285.623823,7293.32944 285.819846,7286.14023 285.872583,7284.97693 C285.924325,7283.83745 286.155174,7282.79624 286.959165,7281.99226 C287.954203,7280.99968 289.239792,7280.51332 297.993144,7280.90837 C299.135448,7280.95998 300.179243,7281.19026 300.985224,7281.99226 C301.980262,7282.98483 302.473801,7284.28014 302.071806,7292.99991 C302.028024,7293.96767 301.865833,7294.49274 301.729513,7294.84312 C300.829003,7297.15085 298.757333,7297.47145 289.951245,7297.06748 M298.089663,7283.68956 C298.089663,7284.34665 298.623998,7284.88065 299.283709,7284.88065 C299.943419,7284.88065 300.47875,7284.34665 300.47875,7283.68956 C300.47875,7283.03248 299.943419,7282.49847 299.283709,7282.49847 C298.623998,7282.49847 298.089663,7283.03248 298.089663,7283.68956 M288.862673,7288.98792 C288.862673,7291.80286 291.150266,7294.08479 293.972194,7294.08479 C296.794123,7294.08479 299.081716,7291.80286 299.081716,7288.98792 C299.081716,7286.17298 296.794123,7283.89205 293.972194,7283.89205 C291.150266,7283.89205 288.862673,7286.17298 288.862673,7288.98792 M290.655732,7288.98792 C290.655732,7287.16159 292.140329,7285.67967 293.972194,7285.67967 C295.80406,7285.67967 297.288657,7287.16159 297.288657,7288.98792 C297.288657,7290.81525 295.80406,7292.29716 293.972194,7292.29716 C292.140329,7292.29716 290.655732,7290.81525 290.655732,7288.98792"
                          id="instagram-[#167]">

                        </path>
                      </g>
                    </g>
                  </g>
                </svg>
              </a>
            </div>
          </div>
          <div class="mb-2 w-100 d-flex justify-content-center align-item-center">
            <a class="px-2 btn btn-primary btn-round btn-lg w-75" [attr.href]="adlink" target="_blank" rel="noopener">
              <i class="fa-solid fa-user mr-2"></i> Area riservata
            </a>
          </div>
        </div>
        <!--Grid column-->
      </div>
    </div>
  </footer>
  <!-- Copyright -->
  <div class="text-center p-3 privacy" style="background-color: rgba(0, 0, 0, 0.2);">
    Copyright 2024 - Protezione Civile Regione Campania - <a style="cursor: pointer;"
      [routerLink]="['/disclaimer/privacy']">Privacy Policy</a> - <a style="cursor: pointer;"
      [routerLink]="['/disclaimer/cookies']">Cookie Policy</a>
    <!-- <i class="pl-2 fa-solid fa-gears" style="cursor: pointer;" (click)="routeTo('/admin')"></i> -->
  </div>
</div>

<ng-template #linkModal let-modal>
  <div class="modal-header" style="background-color: #007bff;padding: 24px;">
    <h4 class="modal-title" style="color: white;">Link utili</h4>
    <button type="button" class="close" (click)="closeSingleModal(modal)">
      <span aria-hidden="true" style="font-size: 3rem; line-height: 1; color: white;">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!--<p style=" font-family: Exo; color: #2a2a2a; font-weight: 500; padding-top: 16px; padding-left: 20px;font-size: 1.125rem;";>
      Mappa dei link ai centri funzionali
      </p>
    <object style="vertical-align:text-top;" type="application/x-shockwave-flash" data="https://centrofunzionale.regione.campania.it/modules/mod_mappa_italia_flash/tmpl/italia.swf" height="600" width="450"><param name="flashvars" value="xmlFile=http%3A//centrofunzionale.regione.campania.it/modules/mod_mappa_italia_flash/tmpl/config.xml"></object>-->
    <div class="linkclass"
      style="margin-top:10px;padding-left: 20px;padding-right: 20px; color:black;padding-bottom: 11px; ">

      <span>
        Di seguito si riportano alcuni dei siti che, per affinità istituzionale e/o condivisione di ambiti scientifici e
        operativi da parte dei soggetti linkati, potrebbero risultare di interesse dell’utenza di questo sito.
      </span>
      <br>
      <span>
        Per eventuali richieste o segnalazioni, far riferimento all’indirizzo centrofunzionale&#64;regione.campania.it
      </span>

      <ul style="margin-top:30px;">
        <!--
      <li><a class="colorhoverfooter"  href="http://www.protezionecivile.gov.it/jcms/it/cfcri.wp"		onclick="window.open(this.href, 'Link utili','left=20,top=20,width=800,height=700,toolbar=0,resizable=1'); return false;" >Dipartimento Protezione Civile - Centro Funzionale Centrale</a></li>
      <li><a class="colorhoverfooter" href="https://www.meteotrentino.it/#!/home" 		onclick="window.open(this.href, 'Link utili','left=20,top=20,width=800,height=700,toolbar=0,resizable=1'); return false;" >CFD della Provincia Autonoma di Trento</a></li>
      <li><a class="colorhoverfooter"  href="http://www.reward-project.eu/" 		onclick="window.open(this.href, 'Link utili','left=20,top=20,width=800,height=700,toolbar=0,resizable=1'); return false;"  >Reward</a></li>
      <li><a class="colorhoverfooter" href="http://www.provincia.bz.it/sicurezza-protezione-civile/protezione-civile/default.asp"		onclick="window.open(this.href, 'Link utili','left=20,top=20,width=800,height=700,toolbar=0,resizable=1'); return false;"  >CFD della Provincia Autonoma di Bolzano</a></li>
      <li><a class="colorhoverfooter" href="http://www.regioni.it/informazioni/" 		onclick="window.open(this.href, 'Link utili','left=20,top=20,width=800,height=700,toolbar=0,resizable=1'); return false;"  >Conferenza Regioni - Commissione Speciale Protezione Civile</a></li>
      <li><a class="colorhoverfooter" href="http://meteoniardo.altervista.org/portale-dei-dati-idrologici-italiani.html" 		onclick="window.open(this.href, 'Link utili','left=20,top=20,width=800,height=700,toolbar=0,resizable=1'); return false;"  >Portale dati idrologici italiani</a></li>
      <li><a class="colorhoverfooter"  href="http://www.lavoripubblici.regione.campania.it/joomla/" 		onclick="window.open(this.href, 'Link utili','left=20,top=20,width=800,height=700,toolbar=0,resizable=1'); return false;"  >Portale tematico Lavori Pubblici Regione Campania</a></li>
      -->
        <li><a class="colorhoverfooter" href="https://www.protezionecivile.gov.it/it/" target="_blank" rel="noopener">Dipartimento
            della Protezione Civile</a></li>
        <li><a class="colorhoverfooter" href="https://mappe.protezionecivile.gov.it/it/mappe-rischi/bollettino-di-vigilanza/" target="_blank" rel="noopener">Bollettino Dipartimento di Vigilanza Meteorologica Nazionale</a></li>
        <li>
          <a class="colorhoverfooter" href="https://www.regione.campania.it" target="_blank" rel="noopener">Regione Campania</a></li>
        
        <li><a class="colorhoverfooter"
            href="https://www.regione.campania.it/regione/it/tematiche/magazine-protezione-civile" target="_blank" rel="noopener">Protezione Civile Regione Campania – Area Tematica</a></li>

        <li><a class="colorhoverfooter" href="https://bollettinimeteo.regione.campania.it/" target="_blank" rel="noopener">Protezione Civile Regione Campania – Bollettini Meteo</a></li>

        <li><a class="colorhoverfooter" href="https://portaleprotezionecivile.regione.campania.it/" target="_blank" rel="noopener">Portale Protezione Civile Regione Campania</a></li>

        <li><a class="colorhoverfooter" href="https://protezionecivile-geniocivile.regione.campania.it/" target="_blank" rel="noopener">Direzione Generale Protezione Civile e Uffici Territoriali del Genio Civile</a></li>
        
          <li><a class="colorhoverfooter" href="http://www.meteoam.it/" target="_blank" rel="noopener">Servizio Meteorologico dell'Aereonautica Militare</a></li>

        <li><a class="colorhoverfooter" href="http://www.isprambiente.gov.it/it" target="_blank" rel="noopener">ISPRA</a>
        </li>
        <li><a class="colorhoverfooter" href="https://www.arpacampania.it/" target="_blank" rel="noopener">ARPA Campania</a>
        </li>

      </ul>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="modal.close()">Chiudi</button>
  </div>
</ng-template>